import React from "react";
import "./HomeAccordion.css";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Link } from "react-router-dom";

function HomeAccordion() {
  return (
    <div className="homeAccordion">
      <Accordion className="mt-5 homeaccordion-container">
        <AccordionTab
          headerTemplate={() => (
            <div className="homeaccordion-header-custom">
              <span className="accordion-custom-title">
                LEARN MORE ABOUT US
              </span>
              <span className="homeaccordion-icon">
                <img src="/images/plusiconaccordion.svg" width={30} />
              </span>
            </div>
          )}
        >
          <p>
            Your partner in wellness: reliable, precise, and innovative. At
            Medic Devices, we’ve led the way in aesthetic, medical, and
            physiotherapy equipment since 2012. Discover why we’re trusted by
            professionals across the nation. Discover the future of aesthetic,
            medical, laser, and physiotherapy equipment with Medic Devices. From
            cutting-edge technology to unparalleled service, we’re committed to
            advancing wellness solutions across Lebanon.  Explore our range
            today and elevate your practice with precision and excellence.
          </p>
        </AccordionTab>
        <AccordionTab
          headerTemplate={() => (
            <div className="homeaccordion-header-custom">
              <span className="accordion-custom-title">
                CHECK OUT OUR PRODUCTS
              </span>
              <img src="/images/plusiconaccordion.svg" width={30} />
            </div>
          )}
        >
          <p>
            At Medic Devices, we proudly offer a growing selection of
            cutting-edge aesthetic, laser, and physiotherapy machines from
            leading international brands. Our carefully curated portfolio
            reflects our commitment to innovation, quality, and delivering the
            best in medical technology across Lebanon.
          </p>
        </AccordionTab>
      </Accordion>
      <div className="accordionlink">
        <Link to="/faq">FAQs</Link>
        <Link to="/contact">PATRNER WITH US</Link>
      </div>
    </div>
  );
}

export default HomeAccordion;
